var map = {
	"./bg/track.mp3": "592a",
	"./bonus_animal_hit.mp3": "4c42",
	"./camera_shutter_01.mp3": "4f65",
	"./helicopter_loop.mp3": "53be",
	"./hit_MTV.mp3": "9023",
	"./hit_baggage.mp3": "9593",
	"./hit_checkMark.mp3": "0420",
	"./hit_redFlag.mp3": "a6b2",
	"./hit_tree.mp3": "31ea",
	"./hit_youUp.mp3": "dc71",
	"./jump.mp3": "7382",
	"./land.mp3": "95c7",
	"./obstacleDeath.mp3": "e205",
	"./stop.mp3": "d1c7",
	"./target_missed.mp3": "293d",
	"./yetiDeath.mp3": "7b21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6372";